module.exports = __webpack_public_path__ + "img/fort-awesome.214be5d8.svg";